<template>
  <div class="step1" v-loading="loadingAll" element-loading-text="正在解析数据，请稍候...">
    <!-- 顶部引导条：单行说明 + 下载按钮 -->
    <div class="hero-card">
      <div class="hero-left">
        <div class="hero-icon"><i class="el-icon-upload2"></i></div>
        <div class="hero-info">
          <h3 class="hero-title">数据导入</h3>
          <p class="hero-desc">
            推荐使用
            <span class="hero-link" @click="downloadAction">下载导入模板</span>
            ，填写后上传可减少表头匹配工作。
          </p>
        </div>
      </div>
      <el-button type="primary" plain icon="el-icon-download" class="hero-btn" @click="downloadAction">
        下载导入模板
      </el-button>
    </div>

    <!-- 上传 + Sheet/表头行合并为一张卡 -->
    <div class="upload-card">
      <div class="section-title">
        <span class="bar"></span>
        上传文件
        <span class="section-sub">支持 .xls / .xlsx，单个文件不超过 10MB</span>
      </div>

      <div class="uploadBox">
        <el-upload
          v-loading="loading"
          :show-file-list="false"
          multiple="false"
          :on-success="fileUploadSuccess"
          :on-error="fileUploadError"
          :before-upload="beforeFileUpload"
          :action="uploadUrl"
          :file-list="fileList"
          :on-change="handleChange"
          :on-exceed="handleExceed"
          class="uploadContent"
          drag
          accept=".xls,.xlsx"
        >
          <div class="upload-inner">
            <div class="upload-icon"><i class="el-icon-upload"></i></div>
            <p class="upload-title">点击或将文件拖拽到此处上传</p>
            <p class="upload-sub">仅支持 .xls / .xlsx 格式，单个文件不超过 10MB</p>
          </div>
        </el-upload>
      </div>

      <!-- 已上传文件提示 -->
      <div v-if="uploadTempInfo.fileId" class="uploaded-file">
        <i class="el-icon-document"></i>
        <span class="file-name">{{ uploadTempInfo.fileName }}</span>
        <i class="el-icon-circle-check file-ok"></i>
      </div>

      <!-- Sheet / 表头行 / 导入方式：同一行内排布 -->
      <div class="extra-grid">
        <div v-if="sheetHide" class="extra-item">
          <span class="extra-label required">Sheet 页</span>
          <el-select
            v-model="sheetName"
            class="extra-control"
            @change="changeValue"
            :disabled="sheetDisabled"
            placeholder="请选择 Sheet 页"
          >
            <el-option
              v-for="sheet in sheetNameList"
              :key="sheet.sheetName"
              :label="sheet.sheetName"
              :value="sheet.sheetName"
            ></el-option>
          </el-select>
        </div>

        <div class="extra-item extra-item--row">
          <span class="extra-label required">表头所在行</span>
          <div class="row-input-wrap">
            <span class="row-text">第</span>
            <el-input
              v-model="headerRow"
              class="row-input"
              :disabled="sheetDisabled"
              placeholder="1"
              @input="changeRowAction(headerRow)"
            ></el-input>
            <span class="row-text">行</span>
          </div>
        </div>

        <div v-if="isShow" class="extra-item">
          <span class="extra-label required">导入方式</span>
          <el-select
            v-model="operation"
            class="extra-control"
            @change="operationChangeValue"
            placeholder="请选择导入方式"
          >
            <el-option
              v-for="item in operationList"
              :key="item.codeItemId"
              :label="item.codeItemName"
              :value="item.codeItemId"
            ></el-option>
          </el-select>
        </div>
      </div>

      <div v-if="headerRowError" class="error-tip">
        <i class="el-icon-warning-outline"></i>
        <span>{{ headerMessage }}</span>
      </div>
      <div v-if="isShow" class="error-tip">
        <i class="el-icon-warning-outline"></i>
        <span>您输入的行数未查找到数据</span>
      </div>
    </div>

    <!-- 温馨提示 + 按钮同一行，减少纵向高度 -->
    <div class="bottom-bar">
      <div class="footer-tips">
        <i class="el-icon-info tip-icon"></i>
        <span>支持 xls / xlsx 且不超过 10M；请勿加密模板文件，否则将导致错误。</span>
      </div>
      <el-button v-if="nextFlag" type="primary" class="primary-btn" @click="next()">
        上传并解析<i class="el-icon-right el-icon--right"></i>
      </el-button>
    </div>
  </div>
</template>

<script>
import { mapGetters, mapMutations } from 'vuex';
import { downloadFile } from "@/util/util";
import { downloadBatchDetailExcelTmpl, uploadStepOne, getSheetName } from "@/api/wage/batchTemplate";

export default {
  name: "step1",
  props: {
    formInline: { type: Object, default: {} },
    templateId: { type: String, default: '' },
    step: { type: String, default: '' },
    step4Info: { type: Object, default: {} },
    sheetNameParam: { type: String, default: '' },
    batchInfoDetail: { type: Object, default: {} },
  },
  computed: {
    ...mapGetters(['dicts', 'pms']),
  },
  data() {
    return {
      fileList: [],
      operation: '',
      isShow: false,
      operationList: [],
      uploadUrl: "/api/file",
      loading: false,
      loadingAll: false,
      nextFlag: false,
      tmplInfo: {
        tmplId: "",
        fileName: '薪资模板.xls'
      },
      uploadTempInfo: {
        fileId: '',
        fileName: '',
      },
      sheetNameList: [],
      headerList: {},
      sheetName: "",
      sheetHide: false,
      headerRow: "",
      headerRowError: false,
      headerMessage: "",
      headerRowMax: "",
      sheetDisabled: true,
      step2Info: {}
    };
  },
  created() {
    this.operationList = this.dicts.codeList['9252'];
  },
  methods: {
    ...mapMutations(['SET_step2Info']),

    handleChange(file, fileList) {
      this.fileList = fileList.slice(-1);
    },

    changeRowAction(value) {
      var valueReplace = value.replace(/\s+/g, "");
      if (value && valueReplace.length != value.length) {
        this.$set(this, "headerRow", valueReplace);
        this.$emit('update:headerRow', valueReplace);
        return;
      }
      this.$emit('update:headerRow', value);
      if (value != null && value.replace(/\s+/g, "").length > 0) {
        value = value.replace(/\s+/g, "");
        var regNum = /^[1-9][0-9]*$/;
        if (!regNum.test(value)) {
          this.headerRowError = true;
          this.nextFlag = false;
          this.$set(this, "headerMessage", "输入内容不合法，请输入整数");
        } else {
          if (value > this.headerRowMax || value == 0) {
            this.headerRowError = true;
            this.nextFlag = false;
            let fanWei = "1";
            if (this.headerRowMax != 1) {
              fanWei = "1-" + this.headerRowMax;
            }
            this.$set(this, "headerMessage", "有效行范围为：" + fanWei);
          } else {
            this.headerRowError = false;
            this.nextFlag = true;
          }
        }
      } else {
        this.headerRowError = false;
        this.nextFlag = false;
      }
    },

    changeValue(value) {
      this.sheetName = value;
      this.$emit('update:sheetNameParam', value);
      for (var key in this.headerList) {
        if (key == value) {
          this.$set(this, "headerRowMax", this.headerList[value]);
          return;
        }
      }
    },

    changeRowValue(value) {
      this.headerRow = value;
      this.$emit('update:headerRow', value);
    },

    operationChangeValue(value) {
      this.operation = value;
      this.$emit('update:operation', this.operation);
    },

    downloadAction() {
      let templateId = this.templateId;
      var selectedtemplateId = JSON.parse(sessionStorage.getItem("selectedtemplateId"));
      if (selectedtemplateId == "wumoban") {
        this.$message.error("请选择工资表模版!");
        return;
      } else {
        this.tmplInfo.tmplId = templateId;
        this.tmplInfo.region = this.formInline.region;
        downloadBatchDetailExcelTmpl(this.tmplInfo).then(res => {
          downloadFile(res);
        });
      }
    },

    beforeFileUpload(file) {
      let checkTemptId = this.templateId;
      let batchName = this.batchInfoDetail.batchName;
      let wageMonth = this.batchInfoDetail.wageMonth;
      let socMonth = this.batchInfoDetail.socMonth;
      let taxMonth = this.batchInfoDetail.taxMonth;
      let errorMessage = null;
      this.uploadTempInfo.fileId = null;
      this.uploadTempInfo.fileName = null;

      if (checkTemptId == null || checkTemptId.length == 0) {
        errorMessage = "请选择工资模板";
      }
      if (batchName == null || batchName.length == 0) {
        errorMessage = errorMessage ? errorMessage + "，请输入批次名称" : "请输入批次名称";
      }
      if (wageMonth == null || wageMonth.length == 0) {
        errorMessage = errorMessage ? errorMessage + "，请选择工资月份" : "请选择工资月份";
      }
      if (socMonth == null || socMonth.length == 0) {
        errorMessage = errorMessage ? errorMessage + "，请选择社保月份" : "请选择社保月份";
      }
      if (taxMonth == null || taxMonth.length == 0) {
        errorMessage = errorMessage ? errorMessage + "，请选择税金月份" : "请选择税金月份";
      }

      if (errorMessage != null) {
        this.$message.error(errorMessage);
        return false;
      }

      this.$set(this, "loading", true);
      let isExcel = true;
      const isxls = file.type === "application/vnd.ms-excel";
      const isxlsx = file.type === "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet";
      const isLtM = file.size / 1024 / 1024 < 10;

      if (!isxls && !isxlsx) {
        isExcel = false;
        this.$message.error("导入文件只能是 xls,xlsx 格式!");
        this.$set(this, "loading", false);
        return false;
      }
      if (!isLtM) {
        this.$message.error("导入文件大小不能超过 10MB!");
        this.$set(this, "loading", false);
        return false;
      }
      return isExcel && isLtM;
    },

    fileUploadSuccess(res, file, fileList) {
      this.$set(this, "loading", false);
      if (res) {
        this.$set(this.uploadTempInfo, "fileId", file.response.fileId);
        this.$set(this.uploadTempInfo, "fileName", file.response.fileName);

        this.headerList = {};
        getSheetName(this.uploadTempInfo).then(res => {
          if (res.data.code == 0) {
            let message = "上传成功，请选择 sheet 页和表头所在行";
            this.sheetNameList = res.data.data.sheetCode;
            this.nextFlag = true;
            this.sheetDisabled = false;
            this.sheetName = this.sheetNameList[0].sheetName;
            if (res.data.data.headerList) {
              this.headerList = res.data.data.headerList;
              this.headerRow = "1";
              this.headerRowMax = res.data.data.headerList[this.sheetNameList[0].sheetName];
            }
            if (this.sheetNameList && this.sheetNameList.length > 1) {
              this.$set(this, 'sheetHide', true);
            } else {
              this.$set(this, 'sheetHide', false);
              message = "上传成功，请选择表头所在行";
            }
            this.$emit('update:sheetNameParam', this.sheetNameList[0].sheetName);
            this.$emit('update:headerRow', "1");
            this.$message.success(message);
          } else {
            this.$message.error(res.data.msg);
          }
        });
      }
    },

    fileUploadError() {
      this.$set(this, "loading", false);
      this.$message.error("文件上传异常!");
    },

    next() {
      this.loadingAll = true;
      let checkTemptId = this.templateId;
      let sheetName = this.sheetName;
      let wageMonth = this.batchInfoDetail.wageMonth;
      let socMonth = this.batchInfoDetail.socMonth;
      let taxMonth = this.batchInfoDetail.taxMonth;
      let headerRow = this.headerRow;

      if (checkTemptId == null || checkTemptId.length == 0) {
        this.$message.error("请选择工资模板!");
        this.loadingAll = false;
      } else if (sheetName == null || sheetName.length == 0) {
        this.$message.error("请选择sheet页");
        this.loadingAll = false;
      } else if (headerRow == null || !(headerRow.replace(/\s+/g, "").length > 0)) {
        this.$message.error("请选择表头所在行");
        this.loadingAll = false;
      } else if (wageMonth == null) {
        this.$message.error("请选择工资月份");
        this.loadingAll = false;
      } else if (socMonth == null) {
        this.$message.error("请选择社保月份");
        this.loadingAll = false;
      } else if (taxMonth == null) {
        this.$message.error("请选择税金月份");
        this.loadingAll = false;
      } else {
        this.uploadTempInfo.salaryTemplateId = checkTemptId;
        this.uploadTempInfo.sheetName = sheetName;
        this.uploadTempInfo.headerRow = headerRow;
        this.uploadTempInfo.region = this.formInline.region;

        uploadStepOne(this.uploadTempInfo).then(res => {
          this.loadingAll = false;
          if (res.data.code == 0) {
            this.step2Info.headerInfo = res.data.data;
            this.step2Info.batchInfo = this.uploadTempInfo;
            this.step2Info.headerInfo.fileId = this.uploadTempInfo.fileId;
            this.sheetNameParam = sheetName;
            this.$store.commit('SET_step2Info', this.step2Info);
            this.$emit("update:sheetNameParam", sheetName);
            this.$emit('update:step', 'step2');
            this.$emit('update:disabled', true);
          }
        }).catch(() => {
          this.loadingAll = false;
        });
      }
    }
  }
};
</script>

<style scoped>
.step1 {
  padding: 0 4px 4px;
  color: #1D2129;
}

/* ---------- 顶部引导条（更矮） ---------- */
.hero-card {
  display: flex;
  align-items: center;
  justify-content: space-between;
  flex-wrap: wrap;
  gap: 12px;
  padding: 12px 18px;
  border-radius: 10px;
  background: linear-gradient(135deg, #EEF3FF 0%, #F7FAFF 60%, #FFFFFF 100%);
  border: 1px solid #E2E9F6;
  margin-bottom: 12px;
}
.hero-left {
  display: flex;
  align-items: center;
  gap: 12px;
  min-width: 0;
}
.hero-icon {
  width: 36px;
  height: 36px;
  flex: 0 0 36px;
  border-radius: 10px;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 18px;
  color: #fff;
  background: linear-gradient(135deg, #2F5BFF 0%, #6E9BFF 100%);
  box-shadow: 0 4px 12px rgba(47, 91, 255, .24);
}
.hero-title {
  margin: 0 0 2px;
  font-size: 14px;
  font-weight: 600;
}
.hero-desc {
  margin: 0;
  font-size: 12px;
  color: #86909C;
  line-height: 1.5;
}
.hero-link {
  color: #2F5BFF;
  cursor: pointer;
  font-weight: 500;
  padding: 0 2px;
}
.hero-link:hover {
  text-decoration: underline;
}
.hero-btn {
  border-radius: 8px;
  font-weight: 500;
  height: 32px;
  padding: 0 14px;
}

/* ---------- 上传卡片（上传统一卡） ---------- */
.upload-card {
  background: #fff;
  border: 1px solid #EDF0F5;
  border-radius: 12px;
  padding: 14px 18px 16px;
  box-shadow: 0 2px 12px rgba(29, 33, 41, .04);
  margin-bottom: 12px;
}
.section-title {
  display: flex;
  align-items: center;
  gap: 8px;
  font-size: 14px;
  font-weight: 600;
  margin-bottom: 12px;
}
.section-title .bar {
  width: 3px;
  height: 14px;
  border-radius: 2px;
  background: linear-gradient(180deg, #2F5BFF 0%, #7AA1FF 100%);
}
.section-sub {
  font-size: 12px;
  font-weight: 400;
  color: #A9AEB8;
  margin-left: 4px;
}

/* 上传区：高度压缩 */
.uploadBox >>> .el-upload {
  width: 100%;
}
.uploadBox >>> .el-upload-dragger {
  width: 100%;
  height: 150px;
  display: flex;
  align-items: center;
  justify-content: center;
  background: linear-gradient(180deg, #FAFBFF 0%, #F5F8FF 100%);
  border: 1.5px dashed #C4D4FF;
  border-radius: 10px;
  transition: all .25s ease;
  overflow: hidden;
}
.uploadBox >>> .el-upload-dragger:hover {
  border-color: #2F5BFF;
  background: #F2F6FF;
  transform: translateY(-2px);
  box-shadow: 0 10px 24px rgba(47, 91, 255, .10);
}
.upload-inner {
  text-align: center;
  padding: 0 16px;
}
.upload-icon {
  width: 44px;
  height: 44px;
  margin: 0 auto 8px;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  background: #fff;
  box-shadow: 0 6px 16px rgba(47, 91, 255, .14);
}
.upload-icon i {
  font-size: 22px;
  color: #2F5BFF;
  line-height: 1;
}
.upload-title {
  margin: 0 0 4px;
  font-size: 14px;
  font-weight: 600;
  color: #1D2129;
}
.upload-sub {
  margin: 0;
  font-size: 12px;
  color: #A9AEB8;
}

.uploaded-file {
  display: inline-flex;
  align-items: center;
  gap: 8px;
  margin-top: 10px;
  padding: 6px 12px;
  border-radius: 8px;
  background: #F0FAF3;
  border: 1px solid #D6F0DF;
  font-size: 12px;
  color: #00B42A;
  max-width: 100%;
}
.uploaded-file .file-name {
  color: #1D2129;
  max-width: 320px;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}
.uploaded-file .file-ok {
  font-size: 14px;
}

/* Sheet / 表头行 / 导入方式：行内紧凑 */
.extra-grid {
  display: flex;
  flex-wrap: wrap;
  gap: 10px 20px;
  margin-top: 12px;
}
.extra-item {
  display: flex;
  align-items: center;
  gap: 8px;
  min-width: 0;
}
.extra-label {
  flex: 0 0 auto;
  font-size: 13px;
  font-weight: 500;
  color: #4E5969;
  white-space: nowrap;
}
.extra-label.required::before {
  content: '*';
  color: #F53F3F;
  margin-right: 3px;
}
.extra-control {
  width: 190px;
}
.extra-control >>> .el-input__inner {
  border-radius: 8px;
  height: 32px;
  line-height: 32px;
}
.row-input-wrap {
  display: flex;
  align-items: center;
  gap: 6px;
}
.row-text {
  font-size: 13px;
  color: #86909C;
  white-space: nowrap;
}
.row-input {
  width: 80px;
}
.row-input >>> .el-input__inner {
  border-radius: 8px;
  text-align: center;
  height: 32px;
  line-height: 32px;
}

/* 错误提示 */
.error-tip {
  display: flex;
  align-items: center;
  gap: 8px;
  margin-top: 10px;
  padding: 6px 12px;
  border-radius: 8px;
  background: #FFF5F5;
  border: 1px solid #FFD2D2;
  font-size: 12px;
  color: #F53F3F;
}
.error-tip i {
  font-size: 14px;
}

/* ---------- 底部：提示 + 按钮同一行 ---------- */
.bottom-bar {
  display: flex;
  align-items: center;
  justify-content: space-between;
  flex-wrap: wrap;
  gap: 12px;
  margin-top: 4px;
}
.footer-tips {
  display: flex;
  align-items: center;
  gap: 8px;
  flex: 1;
  min-width: 240px;
  padding: 10px 14px;
  border-radius: 8px;
  background: #F7F8FA;
  border-left: 3px solid #2F5BFF;
  font-size: 12px;
  color: #86909C;
  line-height: 1.6;
}
.footer-tips .tip-icon {
  color: #2F5BFF;
  font-size: 14px;
}
.primary-btn {
  min-width: 160px;
  height: 40px;
  font-size: 14px;
  font-weight: 500;
  border-radius: 10px;
  border: none;
  background: linear-gradient(135deg, #2F5BFF 0%, #5B8CFF 100%);
  box-shadow: 0 8px 20px rgba(47, 91, 255, .28);
  transition: all .25s ease;
}
.primary-btn:hover {
  transform: translateY(-1px);
  box-shadow: 0 10px 26px rgba(47, 91, 255, .36);
  background: linear-gradient(135deg, #2A52E8 0%, #5182FF 100%);
}

/* ---------- 小屏适配 ---------- */
@media (max-width: 768px) {
  .hero-card {
    flex-direction: column;
    align-items: flex-start;
  }
  .extra-item {
    width: 100%;
  }
  .extra-control {
    flex: 1;
    width: auto;
  }
  .bottom-bar {
    flex-direction: column;
    align-items: stretch;
  }
  .primary-btn {
    width: 100%;
  }
}
</style>
